module.exports = __webpack_public_path__ + "img/input.f5e8eeb3.svg";